import BaseObject from './objects/BaseObject';
export default class HttpParseResponse {
    response = null;
    included = [];
    meta = {};
    links = {};
    data = null;
    message = undefined;
    mapObjects;
    /**
     *
     * @param data
     */
    setResponse({ data }) {
        const { included, meta, links, message, } = data;
        this.data = data.data;
        if (Array.isArray(included)) {
            this.included = included;
        }
        if (!!meta) {
            this.meta = meta;
        }
        if (!!links) {
            this.links = links;
        }
        if (!!message) {
            this.message = message;
        }
        return this;
    }
    /**
     * Set Included
     *
     * @param included
     */
    setIncluded(included) {
        this.included = included;
        return this;
    }
    parser(paginate = false) {
        const { data, meta, included, links, message, } = this;
        const parseData = this.parseJson(data);
        if (paginate) {
            return {
                data: parseData,
                meta,
                included,
                links,
                message,
            };
        }
        return parseData;
    }
    /**
     * Discriminates if the object type is array and calls to map
     *
     * @param data
     * @returns {*&{id: *}}
     */
    parseJson(data) {
        if (!Array.isArray(data)) {
            return this.mapObject(data);
        }
        return data.map((t) => this.mapObject(t));
    }
    /**
     * Find object in included
     *
     * @param object
     * @returns {*}
     */
    findObject(object) {
        object = this.included.find((o) => o.type === object.type && o.id === object.id);
        return this.parseJson(object);
    }
    setMapObject(map) {
        this.mapObjects = map;
    }
    /**
     *  Build relations object
     *
     * @param object
     * @param relationships
     * @protected
     */
    mapRelations(object, relationships) {
        object.setHttpParseResponse(this);
        object.setIncluded(this.included);
        object.setRelations(relationships);
        return this;
    }
    mapObject = (tmp) => {
        let object = new BaseObject({});
        if (!!tmp) {
            if (!tmp.type) {
                throw Error(`Object not defined: ${JSON.stringify(tmp)}`);
            }
            const mappedObject = this.mapObjects[tmp.type];
            object = mappedObject(tmp);
            if (!!tmp.relationships && typeof object !== 'undefined') {
                this.mapRelations(object, tmp.relationships);
            }
            return object;
        }
        return tmp;
    };
}
